import {
  EmailReportAsset,
  EmailReportAssetCreateRequest,
  EmailReportAssetUpdateRequest,
} from '../../types/app/emailReportAsset.types';
import { api } from '../core/api';

export const getEmailReportAssetList = (parentId: number) =>
  api
    .get<EmailReportAsset[]>(`EmailReportAsset/GetList?parentId=${parentId}`)
    .then((res) => res.data);

export const getEmailReportAsset = (id: number) =>
  api.get<EmailReportAsset>(`EmailReportAsset/GetItem/?id=${id}`).then((res) => res.data);

export const updateEmailReportAsset = (data: EmailReportAssetUpdateRequest) =>
  api.put(`EmailReportAsset/UpdateItem`, data).then((res) => res.data);

export const createEmailReportAsset = (data: EmailReportAssetCreateRequest) =>
  api.post(`EmailReportAsset/CreateItem`, data).then((res) => res.data);

export const deleteEmailReportAsset = (id: number) =>
  api.delete<EmailReportAsset>(`EmailReportAsset/DeleteItem/?id=${id}`).then();
